export const A11Y_BM_SCAN_PENDING_PARAM = 'a11yBmScanPending';
//# sourceMappingURL=constants.js.map